// ==================== Core ExitLogic Types ====================
// Enum for group types
export var GroupType;
(function (GroupType) {
    GroupType["All"] = "all";
    GroupType["Any"] = "any";
})(GroupType || (GroupType = {}));
// ==================== Requirement Types ====================
// Enum for exit precision options
export var ExitPrecision;
(function (ExitPrecision) {
    ExitPrecision["Duration"] = "duration";
    ExitPrecision["OneMinute"] = "1m";
    ExitPrecision["Exact"] = "exact"; // Use tick/quote data if available
})(ExitPrecision || (ExitPrecision = {}));
// Enum for requirement types
export var RequirementType;
(function (RequirementType) {
    RequirementType["StopLoss"] = "stopLoss";
    RequirementType["ProfitTarget"] = "profitTarget";
    RequirementType["TimeBased"] = "timeBased";
    RequirementType["TechnicalLevel"] = "technicalLevel";
    RequirementType["SupplyDemandZone"] = "supplyDemandZone";
    RequirementType["Pattern"] = "pattern";
    RequirementType["Indicator"] = "indicator";
    RequirementType["ObvEvent"] = "obvEvent";
    RequirementType["ProfitFloor"] = "profitFloor";
    RequirementType["OptionExpiry"] = "optionExpiry";
    RequirementType["DataQuality"] = "dataQuality";
    RequirementType["RegimeParameter"] = "regimeParameter";
})(RequirementType || (RequirementType = {}));
// Enum for stop loss methods
export var StopLossMethod;
(function (StopLossMethod) {
    StopLossMethod["Percentage"] = "percentage";
    StopLossMethod["Price"] = "price";
    StopLossMethod["ATR"] = "atr";
    StopLossMethod["Volatility"] = "volatility";
    StopLossMethod["EntryContext"] = "entryContext";
})(StopLossMethod || (StopLossMethod = {}));
// Enum for profit target methods
export var ProfitTargetMethod;
(function (ProfitTargetMethod) {
    ProfitTargetMethod["Percentage"] = "percentage";
    ProfitTargetMethod["Price"] = "price";
    ProfitTargetMethod["RiskReward"] = "riskReward";
    ProfitTargetMethod["ATR"] = "atr";
    ProfitTargetMethod["EntryContext"] = "entryContext";
})(ProfitTargetMethod || (ProfitTargetMethod = {}));
// Enum for time-based conditions
export var TimeBasedCondition;
(function (TimeBasedCondition) {
    TimeBasedCondition["HoldTime"] = "holdTime";
    TimeBasedCondition["MarketClose"] = "marketClose";
    TimeBasedCondition["BeforeEvent"] = "beforeEvent";
    TimeBasedCondition["SpecificTime"] = "specificTime";
    TimeBasedCondition["WeekendClose"] = "weekendClose";
    TimeBasedCondition["TradingHoldTime"] = "tradingHoldTime";
    TimeBasedCondition["AfterHours"] = "afterHours";
    TimeBasedCondition["PreMarket"] = "preMarket";
    TimeBasedCondition["DayOfWeek"] = "dayOfWeek";
    TimeBasedCondition["TimeRange"] = "timeRange";
    TimeBasedCondition["ConditionalTime"] = "conditionalTime";
})(TimeBasedCondition || (TimeBasedCondition = {}));
// Enum for event types
export var EventType;
(function (EventType) {
    EventType["Earnings"] = "earnings";
    EventType["FOMC"] = "fomc";
    EventType["Custom"] = "custom";
})(EventType || (EventType = {}));
// Technical Level Requirement
// Enums for TechnicalLevelRequirementParameters
export var LevelType;
(function (LevelType) {
    LevelType["Support"] = "support";
    LevelType["Resistance"] = "resistance";
    LevelType["Pivot"] = "pivot";
    LevelType["Fibonacci"] = "fibonacci";
})(LevelType || (LevelType = {}));
export var LevelSource;
(function (LevelSource) {
    LevelSource["Entry"] = "entry";
    LevelSource["Fixed"] = "fixed";
})(LevelSource || (LevelSource = {}));
export var LevelTrigger;
(function (LevelTrigger) {
    LevelTrigger["Touch"] = "touch";
    LevelTrigger["Break"] = "break";
    LevelTrigger["Close"] = "close";
    LevelTrigger["PercentageMove"] = "percentageMove";
    LevelTrigger["Break25"] = "break25";
    LevelTrigger["Break50"] = "break50";
    LevelTrigger["Break75"] = "break75";
    LevelTrigger["FullCandle"] = "fullCandle";
})(LevelTrigger || (LevelTrigger = {}));
export var EntryTechnicalLevelReference;
(function (EntryTechnicalLevelReference) {
    EntryTechnicalLevelReference["NearestSupport"] = "nearestSupport";
    EntryTechnicalLevelReference["NearestResistance"] = "nearestResistance";
    EntryTechnicalLevelReference["StrongestSupportBelow"] = "strongestSupportBelow";
    EntryTechnicalLevelReference["StrongestResistanceAbove"] = "strongestResistanceAbove";
})(EntryTechnicalLevelReference || (EntryTechnicalLevelReference = {}));
export var EntryTechnicalLevelMetricField;
(function (EntryTechnicalLevelMetricField) {
    EntryTechnicalLevelMetricField["PriceLow"] = "priceLow";
    EntryTechnicalLevelMetricField["PriceHigh"] = "priceHigh";
    EntryTechnicalLevelMetricField["PriceMid"] = "priceMid";
    EntryTechnicalLevelMetricField["StrengthScore"] = "strengthScore";
    EntryTechnicalLevelMetricField["DistancePct"] = "distancePct";
})(EntryTechnicalLevelMetricField || (EntryTechnicalLevelMetricField = {}));
export var IndicatorOutputField;
(function (IndicatorOutputField) {
    IndicatorOutputField["Value"] = "value";
    IndicatorOutputField["Upper"] = "upper";
    IndicatorOutputField["Lower"] = "lower";
    IndicatorOutputField["Middle"] = "middle";
    IndicatorOutputField["Vwap"] = "vwap";
})(IndicatorOutputField || (IndicatorOutputField = {}));
export var SupplyDemandZoneReference;
(function (SupplyDemandZoneReference) {
    SupplyDemandZoneReference["EntrySide"] = "entrySide";
    SupplyDemandZoneReference["OpposingSide"] = "opposingSide";
    SupplyDemandZoneReference["NearestDemand"] = "nearestDemand";
    SupplyDemandZoneReference["NearestSupply"] = "nearestSupply";
})(SupplyDemandZoneReference || (SupplyDemandZoneReference = {}));
export var SupplyDemandZoneScope;
(function (SupplyDemandZoneScope) {
    SupplyDemandZoneScope["Entry"] = "entry";
    SupplyDemandZoneScope["Current"] = "current";
})(SupplyDemandZoneScope || (SupplyDemandZoneScope = {}));
export var SupplyDemandZoneBoundary;
(function (SupplyDemandZoneBoundary) {
    SupplyDemandZoneBoundary["LowerBound"] = "lowerBound";
    SupplyDemandZoneBoundary["UpperBound"] = "upperBound";
    SupplyDemandZoneBoundary["ProximalBound"] = "proximalBound";
    SupplyDemandZoneBoundary["DistalBound"] = "distalBound";
    SupplyDemandZoneBoundary["Midpoint"] = "midpoint";
})(SupplyDemandZoneBoundary || (SupplyDemandZoneBoundary = {}));
// Enum for indicator conditions
export var IndicatorCondition;
(function (IndicatorCondition) {
    IndicatorCondition["Above"] = "above";
    IndicatorCondition["Below"] = "below";
    IndicatorCondition["CrossAbove"] = "crossAbove";
    IndicatorCondition["CrossBelow"] = "crossBelow";
})(IndicatorCondition || (IndicatorCondition = {}));
export var IndicatorSource;
(function (IndicatorSource) {
    IndicatorSource["Price"] = "price";
    IndicatorSource["Indicator"] = "indicator";
})(IndicatorSource || (IndicatorSource = {}));
export var CompareType;
(function (CompareType) {
    CompareType["Indicator"] = "indicator";
    CompareType["Value"] = "value";
})(CompareType || (CompareType = {}));
export var RegimeParameterSource;
(function (RegimeParameterSource) {
    RegimeParameterSource["Current"] = "current";
    RegimeParameterSource["Entry"] = "entry";
    RegimeParameterSource["Delta"] = "delta";
})(RegimeParameterSource || (RegimeParameterSource = {}));
export var RegimeParameterScope;
(function (RegimeParameterScope) {
    RegimeParameterScope["Market"] = "market";
    RegimeParameterScope["Entity"] = "entity";
    RegimeParameterScope["Relative"] = "relative";
})(RegimeParameterScope || (RegimeParameterScope = {}));
export var RegimeParameterField;
(function (RegimeParameterField) {
    RegimeParameterField["BullishProbability"] = "bullishProbability";
    RegimeParameterField["BearishProbability"] = "bearishProbability";
    RegimeParameterField["RiskOnProbability"] = "riskOnProbability";
    RegimeParameterField["RiskOffProbability"] = "riskOffProbability";
    RegimeParameterField["TransitionProbability"] = "transitionProbability";
    RegimeParameterField["StateEntropy"] = "stateEntropy";
    RegimeParameterField["LatentStateConfidence"] = "latentStateConfidence";
    RegimeParameterField["DaysInLatentState"] = "daysInLatentState";
    RegimeParameterField["ExpectedRemainingStateDays"] = "expectedRemainingStateDays";
    RegimeParameterField["DeterministicAgreementScore"] = "deterministicAgreementScore";
    RegimeParameterField["ContinuationProbability"] = "continuationProbability";
    RegimeParameterField["BreakdownProbability"] = "breakdownProbability";
    RegimeParameterField["MeanReversionProbability"] = "meanReversionProbability";
    RegimeParameterField["BarsInLatentState"] = "barsInLatentState";
    RegimeParameterField["ExpectedRemainingStateBars"] = "expectedRemainingStateBars";
    RegimeParameterField["MarketAlignmentScore"] = "marketAlignmentScore";
    RegimeParameterField["AdverseMoveProbability"] = "adverseMoveProbability";
    RegimeParameterField["OutperformanceProbability"] = "outperformanceProbability";
    RegimeParameterField["UnderperformanceProbability"] = "underperformanceProbability";
    RegimeParameterField["LeadershipPersistenceProbability"] = "leadershipPersistenceProbability";
    RegimeParameterField["CorrelationBreakProbability"] = "correlationBreakProbability";
})(RegimeParameterField || (RegimeParameterField = {}));
export const REGIME_PARAMETER_FIELDS_BY_SCOPE = {
    [RegimeParameterScope.Market]: [
        RegimeParameterField.BullishProbability,
        RegimeParameterField.BearishProbability,
        RegimeParameterField.RiskOnProbability,
        RegimeParameterField.RiskOffProbability,
        RegimeParameterField.TransitionProbability,
        RegimeParameterField.StateEntropy,
        RegimeParameterField.LatentStateConfidence,
        RegimeParameterField.DaysInLatentState,
        RegimeParameterField.ExpectedRemainingStateDays,
        RegimeParameterField.DeterministicAgreementScore
    ],
    [RegimeParameterScope.Entity]: [
        RegimeParameterField.ContinuationProbability,
        RegimeParameterField.BreakdownProbability,
        RegimeParameterField.MeanReversionProbability,
        RegimeParameterField.TransitionProbability,
        RegimeParameterField.StateEntropy,
        RegimeParameterField.LatentStateConfidence,
        RegimeParameterField.BarsInLatentState,
        RegimeParameterField.ExpectedRemainingStateBars,
        RegimeParameterField.MarketAlignmentScore,
        RegimeParameterField.AdverseMoveProbability
    ],
    [RegimeParameterScope.Relative]: [
        RegimeParameterField.OutperformanceProbability,
        RegimeParameterField.UnderperformanceProbability,
        RegimeParameterField.LeadershipPersistenceProbability,
        RegimeParameterField.CorrelationBreakProbability,
        RegimeParameterField.StateEntropy,
        RegimeParameterField.LatentStateConfidence,
        RegimeParameterField.BarsInLatentState,
        RegimeParameterField.ExpectedRemainingStateBars
    ]
};
//# sourceMappingURL=ExitLogicTypes.js.map